import { createFileRoute } from '@tanstack/react-router';
import { TasksPage } from '@/features/draper-chat/activity/tasks-page';
import { useViewerChair } from '@/features/viewer-chair/use-chair';

/** The New operator's Tasks (his tray's Tasks disc): his Draper tasks and the approvals waiting for him. */
export const Route = createFileRoute('/_authed/tasks')({
  component: TasksRoute,
});

function TasksRoute() {
  const { team } = Route.useRouteContext();
  // Switch view's rows: null when she has one chair (a managed client), so the page never tells her to switch.
  const chair = useViewerChair();
  return <TasksPage teamId={team?.id ?? null} canSwitchView={chair.rows !== null} />;
}
